import classNames from 'classnames';
import { ForwardedRef } from 'react';

import LoadingIcon from '../icons/LoadingIcon';
import { BasicButtonElement } from './BasicButton';
import RoundedButton, { RoundedButtonProps } from './RoundedButton';

import styles from '../../styles/buttons/form-button.module.css';

interface FormButtonProps extends RoundedButtonProps {
    loading?: boolean;
    colored?: boolean;
}

function FormButton({
    children = null,
    loading = false,
    colored = false,
    className = null,
    ref: buttonRef = null,
    ...props
}: FormButtonProps & { ref?: ForwardedRef<BasicButtonElement> | null }) {
    return (
        <RoundedButton
            className={classNames([
                styles.container,
                {
                    [styles.colored]: colored,
                    [styles.loading]: loading,
                },
                className,
            ])}
            ref={buttonRef}
            disabled={loading}
            {...props}
        >
            {children}
            {loading ? <LoadingIcon loading className={styles.loadingIcon} /> : null}
        </RoundedButton>
    );
}

export default FormButton;
